module.exports = __webpack_public_path__ + "static/img/moderators.8c4f83c8.png";